import { render, staticRenderFns } from "./Creator.vue?vue&type=template&id=1f85e2d8"
import script from "./Creator.vue?vue&type=script&lang=ts"
export * from "./Creator.vue?vue&type=script&lang=ts"
import style0 from "./Creator.vue?vue&type=style&index=0&id=1f85e2d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports